/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForWorkloadResourceSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForWorkloadResourceSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForWorkloadResourceSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForWorkloadResourceSync>): BackgroundJobPayloadForWorkloadResourceSync {
        let obj = Object.assign(new BackgroundJobPayloadForWorkloadResourceSync(), model);
        BackgroundJobPayloadForWorkloadResourceSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForWorkloadResourceSync>): BackgroundJobPayloadForWorkloadResourceSync {
        if (!model) return null;
        return BackgroundJobPayloadForWorkloadResourceSync.newInstance(<BackgroundJobPayloadForWorkloadResourceSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForWorkloadResourceSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForWorkloadResourceSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForWorkloadResourceSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForWorkloadResourceSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
